<template>
  <transition
    @before-enter="beforeEnter"
    @after-enter="afterEnter"
    @leave="leave"
  >
    <div
      v-show="!isBookingFormVisible && isMounted"
      class="single-counselor-sticky-booking-button"
    >
      <counselor-card-availability-slots :schedule="schedule" />
      <button
        class="btn cta"
        @click="scrollToBookingForm"
        v-text="bookNowText"
      />
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import CounselorCardAvailabilitySlots from 'Main/components/counselor-card/components/availability-slots/CounselorCardAvailabilitySlots.vue';

export default defineComponent({
  name: 'SingleCounselorStickyBookingButton',

  components: {
    CounselorCardAvailabilitySlots,
  },

  props: {
    advisorId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isBookingFormVisible: false,
      isMounted: false,
      observer: null as IntersectionObserver | null,
      bookNowText: window.theme_vars.counselorContactFormTexts.bookNow,
    };
  },

  computed: {
    ...mapState('user', ['schedule']),

    bookingForm() {
      return document.getElementById('booking-form');
    },
  },

  mounted() {
    this.setupIntersectionObserver();
    this.isMounted = true;
  },

  beforeUnmount() {
    this.destroyIntersectionObserver();
  },

  methods: {
    scrollToBookingForm() {
      this.bookingForm?.scrollIntoView({ behavior: 'smooth' });
    },

    setupIntersectionObserver() {
      if (!this.bookingForm) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          // Update visibility state based on intersection
          this.isBookingFormVisible = entries[0].isIntersecting;
        },
        {
          threshold: 0.1, // Show/hide when at least 10% of the booking form is visible
        }
      );

      this.observer.observe(this.bookingForm);
    },

    destroyIntersectionObserver() {
      if (this.observer && this.bookingForm) {
        this.observer.unobserve(this.bookingForm);
        this.observer.disconnect();
        this.observer = null;
      }
    },

    beforeEnter(el: HTMLElement) {
      el.style.transform = 'translateY(100%)';
    },

    afterEnter(el: HTMLElement) {
      el.style.transform = 'translateY(0)';
    },

    leave(el: HTMLElement) {
      el.style.transform = 'translateY(100%)';
    },
  },
});
</script>
